var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg39(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 487,
    height: 157,
    viewBox: "0 0 487 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M418.582 0.242188L350.515 39.3342V117.529L418.582 156.621L486.638 117.529V39.3342L418.582 0.242188Z",
    fill: "#ACA4E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M251.141 0.242188L189.695 29.703L174.525 95.8671L217.064 148.899L285.23 148.91L327.758 95.8671L312.588 29.703L251.141 0.242188Z",
    fill: "#776BCE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1119 0.242188L15.6652 29.703L0.495361 95.8671L43.0236 148.899L111.189 148.91L153.728 95.8671L138.559 29.703L77.1119 0.242188Z",
    fill: "#776BCE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg39);
export default __webpack_public_path__ + "static/media/39.04914445b1f8a6ef99d2d6c4183b35e5.svg";
export { ForwardRef as ReactComponent };